import React from "react";
import PropTypes from "prop-types";
import styles from "./MembershipItem.module.css";
import { ChevronRight } from "react-ikonate";
import icon from "../../assets/Premier_Membership_Icon.svg";
import { useTranslation } from "react-i18next";

export function MembershipItem({
  info,
  onClick,
  hideChevron,
  changesScheduled,
  onMainPage,
  icon,
  hasDigitalDelivery,
  hasDreamStream,
  isFreeTrial,
  compIBOInfo,
  isPremier,
}) {
  const {t} = useTranslation();
  return (
    <div
      className={styles.container}
      onClick={onClick}
      style={{
        cursor: onMainPage ? "pointer" : "default",
      }}
    >
      <div className={styles.membershipDetails}>
        <div className={styles.membershipInfo}>
          {info.type === "Basic Membership" ? (
            <div className={styles.customCircle}>
              <span className={styles.customCircleText}>B</span>
            </div>
          ) : (
            <img
              src={icon}
              alt="Membership Icon"
              className={styles.membershipIcon}
            />
          )}
          <div className={styles.details}>
            <span className={styles.type}>
              {isPremier ? "Premier Membership" : "Basic Membership"}
              {(hasDigitalDelivery || hasDreamStream) && " + "}
              {hasDigitalDelivery && !hasDreamStream && "DreamCast™"}
            </span>
            <ul className={styles.list}>
              {hasDigitalDelivery && hasDreamStream && (
                <li>{t("DreamCast")}</li>
              )}
              {hasDreamStream && (
                <>
                  <li>Topics&#8482;</li>
                </>
              )}
            </ul>
            <div className={styles.priceBilling}>
              {isFreeTrial ? (
                <div className={styles.compIboInfoContainer}>
                  <div className={styles.compIboTitle}>
                    {t("Complimentary New IBO")}
                  </div>
                  <div className={styles.compIboDates}>
                    <div>{t("Began")} {compIBOInfo.began}</div>
                    <div>{t("Expires")} {compIBOInfo.expires}</div>
                  </div>
                  <div className={styles.compIboPricing}>
                    <div>{t("Next Billing")} {compIBOInfo.nextBilling}</div>
                    <div>${info.price}</div>
                  </div>
                </div>
              ) : (
                <>
                  <span className={styles.price}>${info.price && info.price.toFixed(2)}{t("/Mo")}</span>
                  {!changesScheduled && (
                    <span className={styles.nextBilling}>
                      {t("Next Billing")} {info.nextBilling}
                    </span>
                  )}
                </>
              )}
            </div>
            {changesScheduled && (
              <div className={styles.endBilling}>{t("Ends")} {info.endsOn}</div>
            )}
          </div>
        </div>
        {!hideChevron && (
          <div
            className={
              changesScheduled ? styles.chevronChanges : styles.chevron
            }
          >
            <ChevronRight className={styles.dropdownArrow} />
          </div>
        )}
      </div>
    </div>
  );
}

MembershipItem.propTypes = {
  info: PropTypes.shape({
    type: PropTypes.string,
    price: PropTypes.number,
    nextBilling: PropTypes.string,
  }),
  onClick: PropTypes.func,
  hideChevron: PropTypes.bool,
  icon: PropTypes.any,
};
